import { AppDetailsService } from 'src/services';
import { GetServerSideProps } from 'next';
import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import ProtectedPageRoute from 'src/utilities/auth/protectedPageRoute';
import { ReactElement } from 'react';
import RootWidgetLayout from 'src/components/layouts/RootWidgetLayout';
import { Services } from 'src/services/types';
import { Translate } from 'next-translate';
import { myContainer } from 'src/services/inversify.config';
import { AppDetailsPage } from 'src/components/pages/AppDetailsPage';
import { AppDetailsPageProps } from 'src/components/pages/AppDetailsPage/AppDetailsPage.types';

export const getServerSideProps: GetServerSideProps = async (context) =>
  ProtectedPageRoute(context, async () => {
    const { req, params, locale } = context;
    let props: AppDetailsPageProps = {};
    const { site } = req as any as { site?: IMicrositeConfiguration };

    let breadcrumbUrl: string | undefined;
    const prevPage = req.headers.referer;
    const domainName = req.headers.host;
    if (prevPage && domainName) {
      const prevPageIsInternal = prevPage?.includes(domainName);
      const pagesToUseInBreadcrumb = ['search', 'topic'];
      const prevPageIsValidBreadCrumb = pagesToUseInBreadcrumb.some((p) =>
        prevPage.includes(p)
      );

      if (prevPageIsInternal && prevPageIsValidBreadCrumb) {
        breadcrumbUrl = prevPage;
      }
    }

    if (params?.appId && typeof params.appId === 'string') {
      const appDetailsService = myContainer.get<AppDetailsService>(
        Services.AppDetailsService
      );

      const pageData = site
        ? await appDetailsService.getAppDetailsPageData(
            site.tenantId,
            site.packageId,
            params.appId,
            locale
          )
        : undefined;

      if (pageData?.app) {
        // Prevents serializing issue with undefined in large JSON objects (App data)
        props = JSON.parse(
          JSON.stringify({
            pageData,
            pageTitle: pageData.app.name,
            breadcrumbUrl,
          })
        );
      }
    }

    return props;
  });

const AppDetailsPageWrapper = ({
  pageData,
  breadcrumbUrl,
}: AppDetailsPageProps) => {
  return <AppDetailsPage pageData={pageData} breadcrumbUrl={breadcrumbUrl} />;
};

AppDetailsPageWrapper.getLayout = (
  page: ReactElement,
  _t: Translate,
  pageTitle?: string
) => {
  return <RootWidgetLayout pageTitle={pageTitle}>{page}</RootWidgetLayout>;
};

export default AppDetailsPageWrapper;
